import { render, staticRenderFns } from "./PurchasePlnContent.vue?vue&type=template&id=5773676b&lang=pug"
import script from "./PurchasePlnContent.vue?vue&type=script&lang=js"
export * from "./PurchasePlnContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports